import { render, staticRenderFns } from "./EnvHistory.vue?vue&type=template&id=ecdeb01a&scoped=true"
import script from "./EnvHistory.vue?vue&type=script&lang=js"
export * from "./EnvHistory.vue?vue&type=script&lang=js"
import style0 from "./EnvHistory.vue?vue&type=style&index=0&id=ecdeb01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdeb01a",
  null
  
)

export default component.exports